export default "__VITE_ASSET__zj_05mNX__"